<div class="modal-header" appCustomAutofocus>
    <h3>Review your {{category}} election</h3>
</div>
<div class="modal-body">
    <div *ngIf="mode !== 'decline'">
        <div>
            <div *ngIf="alert != null"
                [ngClass]="{'alert alert-success' : alert.type === 'success', 'alert alert-default' : alert.type === 'default', 'alert alert-danger': alert.type === 'danger', 'alert alert-warning' : alert.type === 'warning' }">
                {{alert.msg}}
            </div>
            <div *ngIf="dependents?.length > 0">
                <div *ngIf="formData.showDep && MaxDependentCount != 0">
                    <div *ngIf="formData.showBen">
                        Please select the beneficiaries you would like to associate this benefit with:
                    </div>
                    <div *ngIf="formData.showDep">
                        Please select the dependents you would like to associate this benefit with:
                    </div>
                    <br />
                    <ng-container *ngFor="let dependent of dependents">
                        <div *ngIf="formData.showDep">
                            <input type="checkbox" [(ngModel)]="dependent.IsSelected" (ngModelChange)="updateCount()"
                                [disabled]="dependent.Disabled" />
                            {{dependent.Name}}
                        </div>
                    </ng-container>
                </div>
                <div *ngIf="formData.showBen">
                    <label>Primary:</label>
                    <ng-select [(ngModel)]="formData.Primary" style="margin-bottom: 10px;" (change)="primaryChanged()"
                        [searchable]="false" dropdownPosition="bottom" [items]="dependents" bindLabel="Name"
                        placeholder="No Beneficiary">
                    </ng-select>
                    <div class="row" *ngIf="showPrimaryInput" style="margin-bottom:10px;">
                        <div class="col-lg-6">
                            <label>Name</label>
                            <input [(ngModel)]="formData.primaryInput" class="form-control" maxlength="30" />
                        </div>
                        <div class="col-lg-6">
                            <label>Relationship</label>
                            <input [(ngModel)]="formData.primaryRelationship" class="form-control" />
                        </div>
                    </div>
                    <label>Secondary:</label>
                    <ng-select [(ngModel)]="formData.Secondary" style="margin-bottom: 10px;"
                        (change)="secondaryChanged()" [searchable]="false" dropdownPosition="bottom"
                        [items]="filteredDependents" bindLabel="Name" placeholder="No Beneficiary">
                    </ng-select>
                    <div class="row" *ngIf="showSecondaryInput" style="margin-bottom:10px;">
                        <div class="col-lg-6">
                            <label>Name</label>
                            <input [(ngModel)]="formData.secondaryInput" class="form-control" maxlength="30" />
                        </div>
                        <div class="col-lg-6">
                            <label>Relationship</label>
                            <input [(ngModel)]="formData.secondaryRelationship" class="form-control" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <p *ngIf="mode === 'nochange'">
        Are you sure you want to make no changes to your {{category}} election?<br />
        Your rates may be changed for the upcoming year.

        <span class="row" style="margin-top:10px; margin-left: 1px;">
            Notes:
        </span>
        <input type="text" class="form-control" placeholder="Notes..." [(ngModel)]="formData.Notes"
            style="margin-bottom:15px;" />
    </p>

    <div *ngIf="mode === 'change'">
        <span class="row" style="margin-top:10px;margin-left: 1px;">
            Are you sure you want to submit this change to your {{category}} election?
        </span>

        <span class="row" style="margin-top:10px; margin-left: 1px;">
            Notes:
        </span>
        <input type="text" class="form-control" placeholder="Notes..." [(ngModel)]="formData.Notes"
            style="margin-bottom:15px;" />
    </div>

    <div *ngIf="(mode === 'change' || mode === 'nochange') && formData.showAtt != 0">
        <label style="margin-top: 12px;">New Attachments<span *ngIf="formData.showAtt == 2"
                style="color:red;display:inline-block;">*</span>:</label>
        <br />
        <div class="row">
            <div class="col-lg-4 col-md-4">
                <div ngfDrop multiple="1" selectable="1" [(validDrag)]="validComboDrag" [(files)]="formData.fileDrop"
                    accept=".pdf,.jpg,.jpeg,.gif,.tif,.tiff,.png,.bmp,.doc,.docx,.xls,.xlsx,.ppt,.pps,.pptx,.ppsx,.sldx"
                    [(dragFiles)]="dragFiles" class="drop-box" [class.invalid-drag]="validComboDrag===false"
                    [class.valid-drag]="validComboDrag" (filesChange)="upload()" [ngfFixOrientation]="false"
                    *ngIf="((formData.bulletinMode === 'L' && savedFiles?.length < 1) && (formData.bulletinMode === 'L' && newFiles?.length < 1) )|| formData.bulletinMode !== 'L'">
                    Drop a file or Click to upload
                </div>
            </div>
            <div class="col-lg-8 col-md-8">
                <div *ngFor="let file of formData.newFiles" style="margin-bottom: 5px">
                    {{file.Filename}}
                    <a href="#" (click)="deleteUnsavedAttachment(file)"
                        *ngIf="file.File != null && file.Progress == null" style="color:red;"
                        [disabled]="emailSendWait">Remove</a>
                    <div style="padding-left:15px;margin-top:5px;">
                        <div class="progress" style="width:300px;" *ngIf="file.Progress > 0">
                            <div class="progress-bar" role="progressbar" [style]="{ 'width': file.Progress + '%' }">
                                {{file.Progress}}%</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div *ngIf="mode === 'decline'">
        <form #declineForm="ngForm">
            <p>Are you sure you want to decline coverage?</p>
            <br />
            <div class="row">
                <div class="col-lg-4" *ngIf="showDeclineType">
                    <ng-select [ngClass]="{'is-invalid' : formData.selectedDecline == null && formData.showNote}"
                        [(ngModel)]="formData.selectedDecline" [searchable]="false" [clearable]="false"
                        [required]="formData.selectedDecline == null && formData.showNote" name="option"
                        dropdownPosition="bottom" [items]="declineList" bindLabel="DisplayValue"
                        bindValue="DisplayValue" placeholder="Select a reason">
                    </ng-select>
                </div>
                <div class="col-lg-8" *ngIf="showDeclineType">
                    <input type="text" class="form-control"
                        placeholder="Please describe your reason for declining coverage here."
                        [(ngModel)]="formData.Notes" [required]="formData.showNote" style="margin-bottom:15px;"
                        name="declineType" />
                </div>

                <div class="col-lg-12" *ngIf="!showDeclineType">
                    <input type="text" class="form-control"
                        placeholder="Please describe your reason for declining coverage here."
                        [(ngModel)]="formData.Notes" [required]="formData.showNote" style="margin-bottom:15px;"
                        name="notes" />
                </div>
            </div>
            <quill-view [content]="rejectionText"></quill-view>
        </form>
    </div>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-outline-dark" (click)="closeClicked()">
        Close
    </button>
    <button type="button" class="btn btn-primary" (click)="proceedClicked()"
        [disabled]="notReachMinCount || (mode === 'decline' && ((formData.Notes == null || formData.Notes.trim() === '') && formData.showNote || (formData.selectedDecline == null && showDeclineType && formData.showNote))) || showSecondaryInput && (formData.secondaryInput?.length < 1 || formData.secondaryInput == null) || showPrimaryInput && (formData.primaryInput?.length < 1 || formData.primaryInput == null)  || (formData.showAtt == 2 && formData.newFiles?.length < 1 && (mode === 'change' || mode === 'nochange'))">
        Proceed
    </button>
</div>